/*
// Series Objects follow the following format:
{
    name: 'Series Name',
    // chart type (specifically for multi-chart capable charts)
    type: 'bar',
    data: [
        // DataPoints follow the following format:
        {
            // (grouping, xAxis label, time for time series)
            name: 'Data Point Name ',
            // (value for the data point, always numeric)
            value: 0,

        }
    ]
}
*/

const chartTypes = {
    line: {
        seriesType: 'cartesian',
        isMultiEnabled: true,
        isGoalEnabled: true
    },
    area: {
        seriesType: 'cartesian',
        isMultiEnabled: true,
        isGoalEnabled: true
    },
    bar: {
        seriesType: 'cartesian',
        isMultiEnabled: true,
        isGoalEnabled: true
    },
    column: {
        seriesType: 'cartesian',
        isMultiEnabled: true,
        isGoalEnabled: true
    },
    pie: {
        seriesType: 'category',
        isMultiEnabled: false,
        isGoalEnabled: false
    },
    donut: {
        seriesType: 'category',
        isMultiEnabled: false,
        isGoalEnabled: false
    },
    radialBar: {
        seriesType: 'category',
        isMultiEnabled: false,
        isGoalEnabled: true
    },
    scatter: {
        seriesType: 'cartesian',
        isMultiEnabled: true,
        isGoalEnabled: false
    },
    bubble: {
        seriesType: 'sizedCartesian',
        isMultiEnabled: true,
        isGoalEnabled: false
    },
    heatmap: {
        seriesType: 'sizedCartesian',
        isMultiEnabled: false,
        isGoalEnabled: false
    },
    radar: {
        seriesType: 'cartesian',
        isMultiEnabled: true,
        isGoalEnabled: false
    },
    treemap: {
        seriesType: 'cartesian',
        isMultiEnabled: true,
        isGoalEnabled: false
    }
}

export default chartTypes
